// Friendly display labels for specialism slugs (backend stores slugs).
export const SPECIALISM_LABELS = {
    // Content formats
    "short-form-video": "Short-Form",
    "long-form-video": "Long-Form",
    "short-films": "Short Films",
    "photography": "Photography",
    "graphic-design": "Graphic Design",
    "motion-graphics": "Motion Graphics",
    "illustration": "Illustration",
    "copywriting": "Copywriting",
    "ugc": "UGC Content",
    // Industries
    "fashion-beauty": "Fashion & Beauty",
    "food-drink": "Food & Drink",
    "hotels-property": "Hotels & Property",
    "fitness-wellness": "Fitness & Wellness",
    "tech-lifestyle": "Tech & Lifestyle",
    "travel-culture": "Travel & Culture",
    "b2b-corporate": "B2B Corporate",
    // Legacy slugs (kept for the seeded pool)
    "editing": "Editing",
    "social-strategy": "Social Strategy",
    "food-hospitality": "Food & Hospitality",
};

// The two grouped pickers used at creator onboarding (pick one from each).
export const CONTENT_FORMATS = [
    "short-form-video", "long-form-video", "short-films", "photography",
    "graphic-design", "motion-graphics", "illustration", "copywriting", "ugc",
];
export const INDUSTRIES = [
    "fashion-beauty", "food-drink", "hotels-property", "fitness-wellness",
    "tech-lifestyle", "travel-culture", "b2b-corporate",
];

// One combined list for the creator profile — pick up to 3.
export const ALL_SPECIALISMS = [...CONTENT_FORMATS, ...INDUSTRIES];

export const specLabel = (slug) => SPECIALISM_LABELS[slug] || slug;
